import { DpcSsnInfo, DefaultDpcSsnInfo } from "../block/DpcSsnInfo";
import { OptionalDataInfo, DefaultOptionalDataInfo } from "../number/OptionalDataInfo";
import { SvType } from "../block/SvType";
import { string } from "prop-types";

export type NetworkProfileDto = {
  profileId: string;
  spId: string;
  description: string;
  lrn: string;
  lata: string;
  endUserLocation: string;
  endUserLocationType: string;
  billingId: string;
  svType: keyof typeof SvType;
  networkData: DpcSsnInfo;
  optionalData: OptionalDataInfo;
  selectPriority: string;
  isPrimary: boolean | null;
  isWholesale: boolean;
  chooseCustomers: boolean;
  applyToAll: boolean
  carrier: string;
  type: string;
  companyIds: any;
};

export const DefaultNetworkProfileDto: NetworkProfileDto = {
  profileId: "",
  spId: "",
  lata: "",
  lrn: "",
  endUserLocation: "",
  endUserLocationType: "",
  billingId: "",
  networkData: DefaultDpcSsnInfo,
  optionalData: DefaultOptionalDataInfo,
  description: "",
  svType: SvType.Wireline,
  selectPriority: "",
  chooseCustomers: false,
  applyToAll: false,
  type: "",
  carrier: "",
  isPrimary: null,
  isWholesale: false,
  companyIds: []
};
